interface FetchPerlgemRPCParams {
  method: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  params?: any[];
  id?: number;
}

async function fetchPerlgemRPC<T>({
  method,
  params = [{}],
  id = 1
}: FetchPerlgemRPCParams): Promise<T> {
  const url = `/rpc/jsonrpc.tmpl?dbgmethod=${method}`;
  const postObj = [
    {
      method,
      id,
      params
    }
  ];
  const formData = new URLSearchParams();
  formData.append('JSONRPC', JSON.stringify(postObj));

  try {
    const response = await fetch(url, {
      method: 'POST',
      body: formData
    });
    const responseData = await response.json();

    return responseData[0]?.result?.value;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
  }
}

export default fetchPerlgemRPC;
